import React from "react";
import { Col } from "antd";
import { Button, Icon } from "antd";
import { reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import Title from "../common/Title";
import Description from "../common/Description";
import Hint from "../common/Hint";

const lang = window.lang;

const Thankyou = (props) => {
  const { previousPage } = props;
  const { t } = props;
  return (
    <Col xs={{ span: "24" }} sm={{ span: "24" }}>
      <Title title={"thank_you"} />
      <Description description={"thank_you_desc"} />
      <Hint hint={"thank_you_msg"} id="" />

      <div className="ant-col ant-col-xs-12 ant-col-sm-4">
        <Button
          shape="round"
          block
          type="default"
          onClick={(event) =>
            (window.location.href = "/wps/portal/web/personal")
          }
          className={
            lang === "en" ? ".back-to-home-btn" : ".back-to-home-btn-a"
          }
          id="thanks-BackBtn"
        >
          {t("go_to_home_page")}
          <Icon type={window.lang === "en" ? "arrow-right" : "arrow-left"} />
        </Button>
      </div>
    </Col>
  );
};

export default withTranslation()(
  reduxForm({
    form: "wizard", //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(Thankyou)
);
